import CaptionInput from 'Components/campaigns/collaborations/milestone/components/CaptionInput'
import FileInput from 'Components/campaigns/collaborations/milestone/form/FileInput'
import WYSIWYG from 'Components/campaigns/collaborations/milestone/form/WYSIWYG'
import AddressDetails from 'Components/campaigns/collaborations/milestones/AddressDetail'
import AddressForm from 'Components/campaigns/collaborations/milestones/AddressForm'
import RadioGroup from 'Components/input/RadioGroup/RadioGroup'
import React from 'react'
import { useParams } from 'react-router-dom'
import { FormGroup, Input, Label } from 'reactstrap'
import { GigStepProperty, GigTypeProperty } from 'types/campaign/collaborations'
import { MilestoneProperty } from 'types/campaign/milestones'

const FormField: React.FC<{ error?: string, labelClass?: string, property: GigStepProperty | GigTypeProperty | MilestoneProperty, value: any, onChange: (value: any) => void, showLabel?: boolean, disabled?: boolean }> = ({ showLabel = true, property, value, onChange,error, disabled=false, labelClass='' }) => {

    const {campaignId} = useParams();

    return (
        <FormGroup key={property.key}>
            {
                showLabel &&
                <Label for={property.key} className={`form-label m-0 ${labelClass}`}>{property.label}
                    {property.mandatory && <span className="text-danger"> *</span>}
                </Label>
            }
            {
                property.description &&
                <span className="mb-2 property-desc">{property.description}</span>
            }
            {
                ['text', 'string'].includes(property.type) &&
                <Input disabled={disabled} type='text' className='form-control form-builder-input' value={typeof value === 'string' ? value : ''} onChange={(e) => onChange(e.target.value)} required={property.mandatory} placeholder={property.label} />
            }
            {
                property.type === 'choice' &&
                <select disabled={disabled} className='form-select' value={typeof value === 'string' ? value : ''} onChange={(e) => onChange(e.target.value)} required={property.mandatory}>
                    <option value="">Select</option>
                    {
                        Object.entries((property.choices as {[key: string]: string})).map(([slug, label]) => <option value={slug}>{label}</option> )
                    }
                </select>
            }
            {
                property.type === 'textarea' &&
                <textarea disabled={disabled} rows={4} className='form-control form-builder-textarea' value={typeof value === 'string' ? value : ''} onChange={(e) => onChange(e.target.value)} required={property.mandatory}> </textarea>
            }
            {
                property.type === 'caption' &&
                <CaptionInput value={typeof value === 'string' ? value : ''} onChange={(text) => onChange(text)} hashtags={[]} mentions={[]} />
            }
            {
                property.type === 'number' &&
                <Input disabled={disabled} type='number' className='form-control form-builder-input' value={typeof value === 'string' ? value : ''} onChange={(e) => onChange(e.target.value)} required={property.mandatory} />
            }
            {
                property.type === 'date' &&
                <Input disabled={disabled} type='date' className='form-control form-builder-input' value={typeof value === 'string' ? value : ''} onChange={(e) => onChange(e.target.value)} required={property.mandatory} />
            }
            {
                property.type === 'datetime' &&
                <Input disabled={disabled} type='datetime-local' className='form-control form-builder-input' value={typeof value === 'string' ? value : ''} onChange={(e) => onChange(e.target.value)} required={property.mandatory} />
            }
            {
                property.type === 'file' &&
                <FileInput onChange={(file) => onChange(file)} />
            }
            {
                property.type === 'wysiwyg' &&
                <React.Fragment>
                    <WYSIWYG defaultValue={typeof value === 'string' ? value : ''} onChange={(val) => onChange(val)} />
                </React.Fragment>
            }
            {
                ['permalink', 'url'].includes(property.type) &&
                <Input disabled={disabled} type='url' className='form-control form-builder-input' value={typeof value === 'string' ? value : ''} onChange={(e) => onChange(e.target.value)} required={property.mandatory} />
            }
            {
                property.type === 'tel' &&
                <Input disabled={disabled} type='tel' className='form-control form-builder-input' value={typeof value === 'string' ? value : ''} onChange={(e) => onChange(e.target.value)} required={property.mandatory} />
            }
            {
                property.type === 'boolean' &&

                // <FormGroup switch>
                //     <Input
                //         type='switch'
                //         checked={Boolean(value)}
                //         onChange={(e) => onChange(e.target.checked)}
                //         id={property.key}
                //         required={property.mandatory}
                //     />
                //     <Label className='form-check-label' htmlFor={property.key}>{property.label}</Label>
                // </FormGroup>

                <RadioGroup
                    disabled={disabled}
                    options={[{ label: 'Yes', id: 'y' }, { label: 'No', id: 'n' }]}
                    name={property.key}
                    defaultValue={value ? 'y' : 'n'}
                    onChange={(val) => onChange((val === 'y' ? true : false))}
                    
                />
            }
            {
                property.type === 'address' &&
                <>
                    {
                        value ? (
                            <div className="d-flex flex-row">
                                <div className="flex-fill me-3">
                                    <AddressDetails uuid={value} display='field' />
                                </div>
                                <button className="btn btn-danger btn-icon ms-auto" onClick={() => onChange('')}><i className="bx bx-x"></i></button>
                            </div>
                        ) : (
                           <AddressForm campaignId={campaignId!} />
                        )
                    }
                </>
            }

            {
                error &&
                <span className="text-danger">{error}</span>
            }

        </FormGroup >
    )
}

export default FormField